const cache = {};
const intervalTiming = 5 * 60 * 1000;

setInterval(() => {
    Object.keys(cache).forEach(cacheKey => {
        const cacheEntry = cache[cacheKey];
        const now = new Date().getTime();

        if (cacheEntry.created.getTime() <= now) {
            if (__DEV__) console.log(`Evicting [ ${cacheKey} ] from cache.`);

            clearCache[cacheKey];
        }
    });
}, intervalTiming);

/**
 * @param {string, Array<string>} key - when an array the value will story to each key @jacksonkr
 * @param {object} value
 * @tim.cook
 */
const addToCache = (key, value) => {
    const keys = Array.isArray(key) ? key : [key];

    new Set(keys).forEach(key => {
        if (!cache.hasOwnProperty(key)) {
            cache[key] = {
                created: new Date(),
                value: deepClone(value)
            };
        }
    });
};

const clearCache = key => {
    if (cache.hasOwnProperty(key)) {
        cache[key] = undefined;
    }
};

const getFromCache = key => {
    if (cache.hasOwnProperty(key)) {
        return deepClone(cache[key].value);
    }

    return null;
};

const deepClone = obj => {
    const json = JSON.stringify(obj);
    const copy = JSON.parse(json);
    return copy;
};

export { addToCache, clearCache, getFromCache };
